import i18n from 'i18next'; 
import { initReactI18next } from 'react-i18next';
import langEN from "./langEN.js";
import langJA from "./langJA.js";
import axios from 'axios';
import Api from '../../Api/Api.js';
axios.defaults.headers.post['Content-Type'] = 'application/json';
const defaultLanguage = 'en'; //默认英语
function getParam(queryName) {
  let query = decodeURI(window.location.search.substring(1));
  let vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=");
    if (pair[0] === queryName) { return pair[1]; }
  }
  return null;
}
const pf = getParam("pf");
const lang = getParam("lang");
let default_en = {
  "exomoon.audiodesires.text1":"Listen to sample & sync a Lovense toy",
  "exomoon.audiodesires.text2":"1. Download the Lovense Remote app (iOS/Android)",
  "exomoon.audiodesires.text3":"(Available on App Store and Google Play)",
  "exomoon.audiodesires.text4":"2. Connect your Lovense toy to Lovense Remote",
  "exomoon.audiodesires.text5":"(turn on the toy, open the app, tap the chain icon in the top right corner)",
  "exomoon.audiodesires.text6":"3. Scan the QR Code in Lovense Remote",
  "exomoon.audiodesires.text7":"(tap “+” in the top right corner, choose “Scan QR”)",
  "exomoon.audiodesires.text8":"Don’t own a Lovense toy? <a style='color:#ffffff;cursor:pointer'; href='https://www.lovense.com/public/store' target='_blank' rel='noreferrer'>Click here</a> to find the perfect one for you.",
  "exomoon.audiodesires.text9":"Unsync",
  "bloom.v3.text21": "Connect Now",
}
if (pf==="Audiodesires_demo") {
  let checkLng = "en";
  if (lang) {
    checkLng = lang;
  }
  let  resources = {
      en: {
        translation:default_en
      },
  };
  window.demoBtnOpenUrl = "";
  window.audiodesireslang = default_en["bloom.v3.text21"]
  i18n.use(initReactI18next).init({
    fallbackLng: 'en',
    lng: checkLng,
    debug: false,
    resources: resources,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    }
  });
  let param = {
    "lang": checkLng, // 语言类型短码
    "keyList": [ // key名称列表
      "exomoon.audiodesires.text1",
      "exomoon.audiodesires.text2",
      "exomoon.audiodesires.text3",
      "exomoon.audiodesires.text4",
      "exomoon.audiodesires.text5",
      "exomoon.audiodesires.text6",
      "exomoon.audiodesires.text7",
      "exomoon.audiodesires.text8",
      "exomoon.audiodesires.text9",
      "bloom.v3.text21",
    ]
  }
  axios.post(Api.getLang, param).then(function (res) {
    if (res.data.result) {
      resources[checkLng] = {
        translation:res.data.data
      }
      window.setAudiodesireslang(res.data.data["bloom.v3.text21"])
      i18n.use(initReactI18next).init({
        fallbackLng: 'en',
        lng: checkLng,
        debug: false,
        resources: resources,
        interpolation: {
          escapeValue: false, // not needed for react as it escapes by default
        }
      });
    }
  })
  .catch(function (error) {
    console.log(error);
  });
} else {
  i18n
  .use(initReactI18next) //使用
  .init({ //初始化
    resources: {
      en: {
        translation: langEN
      },
      ja: {
        translation: langJA
      }
    },
    lng: defaultLanguage,
    fallbackLng: defaultLanguage,

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false,
    },
  })
  .then(t => {
    console.log('18n ready');
  });
}


const changeLanguage = lng => { //定义多语言的change 
  i18n.changeLanguage(lng); //i18n会通过这个方法去改变它的语言
};
export { changeLanguage }; //导出
